export default __webpack_public_path__ + "static/media/manage_employers.1e5678f7.svg";